import styled, { css } from 'styled-components';
import { media } from '@simplywallst/ui-core';

interface Props {
  disabled?: boolean;
}

export const CompetitorWrapper = styled('article')<Props>`
  text-align: center;
  border-radius: ${({ theme }) => theme.x1spacePx}px;
  ${({ disabled }) => !disabled && 'cursor: pointer;'}
  flex-shrink: 0;
  width: 37%;
  margin-right: ${({ theme }) => theme.x2spacePx}px;
  ${media.smUp`
    width: 23%;
    margin-right: 6%;
  `}
  ${media.mdUp`
    width: 18%;
  `}
  ${media.lgUp` 
    width: 164px;
    margin-right: ${({ theme }) => theme.x2spacePx}px;
  `}

  ${({ disabled }) =>
    !disabled &&
    css`
      &:hover {
        background-color: var(--s-color-surface-2);
      }
    `}
`;
